<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.branchName')
              }}</label>
            <ts-branch-filter :multiple="false" @filter="setBranchList" class="ts-w-full" ref="branch" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.academicYear')
              }}</label>
            <a-select style="width: 100%" v-model="acYearId" :options="acYearOptions" :show-search="true"
            @change="onAcYearChange"
              :filter-option="filterOption"></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.mainProgram')
              }}</label>
            <a-select style="width: 100%" :disabled="!acYearId" v-model="acpId" :options="mainProgram" @change="getTerm"
              :show-search="true" :filter-option="filterOption" allowClear></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.academicTerm')
              }}</label>
            <a-select style="width: 100%" v-model="acTermId" :options="termLists" :show-search="true"
              :filter-option="filterOption" @change="fetchClass" allowClear></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.className')
              }}</label>
            <a-select
              style="width: 100%"
              v-model="acClassId"
              mode="multiple"
              :options="classList"
              :show-search="true"
              :filter-option="filterOption"
              allowClear
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('totalScoreGenerate.scoringCycle')
              }}</label>
            <a-select style="width: 100%" v-model="cycle" :show-search="true" :filter-option="filterOption" allowClear>
              <a-select-option :value="5">{{
                $t('generatetotalscore.unit')
                }}</a-select-option>
              <a-select-option :value="0">{{
                $t('generatetotalscore.termlyScore')
                }}</a-select-option>
              <a-select-option :value="7">{{
                $t('generatetotalscore.termly')
                }}</a-select-option>
              <a-select-option :value="1">{{
                $t('generatetotalscore.monthlyScore')
                }}</a-select-option>
              <a-select-option :value="6">{{
                $t('generatetotalscore.monthlyForSemester')
                }}</a-select-option>
              <a-select-option :value="2">{{
                $t('generatetotalscore.semesterScore')
                }}</a-select-option>
              <a-select-option :value="3">{{
                $t('generatetotalscore.semesterly')
                }}</a-select-option>
              <a-select-option :value="4">{{
                $t('generatetotalscore.yearly')
                }}</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="row" v-if="cycle == 1">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{ $t('totalScoreGenerate.cycleValue') }}</label>
            <a-select style="width: 100%" v-model="cycleValue" :options="monthlyCycleValues"
              :disabled="!acTermId || monthlyLoading" :loading="monthlyLoading"
              :show-search="true" :filter-option="filterOption" allowClear></a-select>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'drawerFilter',
  data() {
    return {
      loading: false,
      monthlyLoading: false,
      monthlyCycleValues: [],
      monthlyRequestId: 0,
      acYearOptions: [],
      mainProgram: [],
      termLists: [],
      classList: [],
      branchId: undefined
    }
  },
  created() {
    this.fetchAcYear()
  },
  computed: {
    cycle: {
      get() {
        return this.$store.state.generateTotalScore.scoring_cycle_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_SCORING_CYCLE_ID', newValue)
      }
    },
    cycleValue: {
      get() {
        return this.$store.state.generateTotalScore.cycle_value
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_CYCLE_VALUE', newValue)
      }
    },
    acYearId: {
      get() {
        return this.$store.state.generateTotalScore.ac_year_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_AC_YEAR_ID', newValue)
      }
    },
    acpId: {
      get() {
        return this.$store.state.generateTotalScore.acp_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_MAIN_PROGRAM', newValue)
      }
    },
    acTermId: {
      get() {
        return this.$store.state.generateTotalScore.ac_term_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_AC_TERM_ID', newValue)
      }
    },
    acClassId: {
      get() {
        return this.$store.state.generateTotalScore.class_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_CLASS_ID', newValue)
      }
    },
    getStatusTextById: () => statusId => {
      const status = {
        1: "Current",
        2: "History",
        3: "Next"
      }

      return status[statusId] || 'Unknow'
    }
  },
  watch: {
    cycle() {
      this.fetchMonthlyCycleValues()
    },
    acTermId() {
      this.fetchMonthlyCycleValues()
    }
  },
  methods: {
    ...mapActions('generateTotalScore', ['formViewModel']),
    async fetchMonthlyCycleValues() {
      const requestId = ++this.monthlyRequestId
      this.cycleValue = null
      this.monthlyCycleValues = []
      this.monthlyLoading = false
      if (this.cycle != 1 || !this.acTermId) return

      this.monthlyLoading = true
      try {
        const response = await this.formViewModel({
          fnName: 'cycleValue,monthlyForSemester',
          scoring_cycle_id: 1,
          ac_term_id: this.acTermId
        })
        if (requestId !== this.monthlyRequestId) return

        const months = response.monthlyForSemester && response.monthlyForSemester.months
        this.monthlyCycleValues = response.cycleValue
          .filter(el => !months || months.map(Number).includes(Number(el.scoring_cycle_value)))
          .map(el => ({
            value: Number(el.scoring_cycle_value),
            label: el.scoring_cycle_description
          }))
      } catch (error) {
        if (requestId === this.monthlyRequestId) this.$toasted.error(error.message)
      } finally {
        if (requestId === this.monthlyRequestId) this.monthlyLoading = false
      }
    },
    async fetchAcYear() {
      this.loading = true
        await this.formViewModel({
          fnName: 'academicYear',
          branchId: this.branchId
        })
        .then(response => {
          this.acYearOptions = response.academicYear.map(el => ({
            value: el.ac_year_id,
            label: `${el.ac_year} - ${this.getStatusTextById(el.ac_status_id)}`
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('generateTotalScore/getMainProgram')
        .then(response => {
          this.mainProgram = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchClass() {
      this.loading = true
      this.acClassId = []
      this.formViewModel({
        fnName: 'academicClass',
        ac_term_id: this.acTermId
      })
        .then(response => {
          this.classList = response.academicClass.map(el => ({
            value: el.class_id,
            label: `${el.class_name} | ${el.class_desc}`,
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    setBranchList(branch) {
      this.branchId = branch
      this.$store.commit('generateTotalScore/SET_BRANCH_LIST', branch)
      this.fetchAcYear()
      this.acTermId = null
      this.acClassId = []
      this.acYearId = null
      this.acpId = null
    },
    getTerm() {
      this.loading = true
      this.acTermId = null
      this.acClassId = []
      this.formViewModel({
        fnName: 'academicTerm',
        ac_year_id: this.acYearId,
        acp_id: this.acpId,
        branchId: this.branchId
      })
        .then(response => {
          this.termLists = response.academicTerm.map(el => ({
            value: el.ac_term_id,
            label:`${el.term_name} - ${this.getStatusTextById(el.ac_status_id)}`
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },
    clear() {
      const branch = this.$refs.branch
      if(branch) {
        branch.value = []
        this.branchId = undefined
      }

      this.fetchAcYear()
    },
    onAcYearChange(){
      this.acpId = null
      this.getTerm()
    }

  }
}
</script>
